
//系统目录 / 进销存报表 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 查询西药库报表信息展示
export const dgsReport = (data) => {
    return request.post("/outpatient/dgsDpurcTable/dgsReport", data )
}
// 查询西药房报表信息展示
export const dugReport = (data) => {
    return request.post("/outpatient/dugdpurctable/dugReport", data )
}

// 查询中药库报表信息展示
export const dgsReportZY = (data) => {
    return request.post("/outpatient/purctcmtable/dgsTcmReport", data )
}
// 查询中药房报表信息展示
export const dugReportZYF = (data) => {
    return request.post("/outpatient/dugpurctcmtable/dugTcmReport", data )
}
/**
 * 
 * put
 *  
 */

// // 修改采购退货
// export const editdocOut = (data) => {
//     return request.put("/outpatient/docOut", data )
// }

/**
 * 
 * get 
 *  
 */
// 供应商列表
// export const SupplierEntityList = (params) => {
//     return request.get("/outpatient/selectSupplierEntityList", { params })
//     }

/*
 * 
 * DELETE 
 *   
 */  
// export const docOutDel = (params) => {
//     return request.delete("/outpatient/docOut/deleteBy", { params })
// }

// 暴露
export default{
	dgsReport,
	dugReport
}